const angular = require('angular');

const { autocompleteComponentDefinition } = require('./autocomplete.component');

angular.module('oly.common')
    .component('olyAutocomplete', autocompleteComponentDefinition);



// WEBPACK FOOTER //
// ./src/olycommon/autocomplete/index.js